// Centralised data-testid registry — kebab-case, role-based.
export const HOME = {
  emergentLink: "emergent-link",
};

export const IDS = {
  // Header
  headerLogo: "header-logo",
  headerNav: "header-nav",
  headerCta: "header-get-quote-btn",
  mobileMenuToggle: "mobile-menu-toggle",

  // Hero
  heroSection: "hero-section",
  heroPrimaryCta: "hero-get-quote-btn",
  heroSecondaryCta: "hero-download-catalogue-btn",

  // Section anchors
  aboutSection: "about-section",
  productsSection: "products-section",
  whyUsSection: "why-us-section",
  industriesSection: "industries-section",
  marketsSection: "markets-section",
  processSection: "process-section",
  sustainabilitySection: "sustainability-section",
  certsSection: "certs-section",
  faqSection: "faq-section",
  contactSection: "contact-section",

  // Products
  productCard: (id) => `product-card-${id}`,
  productRequestQuote: (id) => `product-request-quote-${id}`,
  productDownloadSpecs: (id) => `product-download-specs-${id}`,

  // Quote dialog
  quoteDialog: "quote-dialog",
  quoteInputName: "quote-input-name",
  quoteInputCompany: "quote-input-company",
  quoteInputCountry: "quote-input-country",
  quoteInputEmail: "quote-input-email",
  quoteInputPhone: "quote-input-phone",
  quoteSelectProduct: "quote-select-product",
  quoteInputQuantity: "quote-input-quantity",
  quoteInputMessage: "quote-input-message",
  quoteSubmit: "quote-submit-btn",
  quoteWhatsapp: "quote-whatsapp-btn",

  // Contact
  contactWhatsapp: "contact-whatsapp-btn",
  contactSendEnquiry: "contact-send-enquiry-btn",

  // FAQ
  faqItem: (i) => `faq-item-${i}`,

  // Footer
  footerLinkedin: "footer-linkedin",
  footerEmail: "footer-email",
  footerWhatsapp: "footer-whatsapp",
};
